module.exports = __webpack_public_path__ + "static/media/kiddy_pool.13ca2ec3.png";